import sha512 from 'js-sha512';

function shaMessage(userID, partnerID, message) {
    let sha = sha512(String(userID + partnerID + message));
    return sha
}

export default shaMessage